import * as React from "react";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker, StaticDatePicker } from "@mui/x-date-pickers";
import "./calendar.css";
import { Backdrop, Box, Button, Fade, Modal, Typography } from "@mui/material";
import PaymentForm from "./NewPayForm";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "#ffe6a7",
  border: "2px solid #ffe6a7",
  boxShadow: 24,
  p: 4,
  borderRadius: 8,
};

export default function ActionBarComponentProps() {
  const [value, setValue] = React.useState(() => dayjs("2022-02-01T00:00"));
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  let windoWidth = window.innerWidth;

  return (
    <>
      {windoWidth > 764 ? (
        <div className="calendar-container">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticDatePicker
              onChange={(newValue) => setValue(newValue)}
              value={value}
              renderInput={(params) => <TextField {...params} />}
              componentsProps={{
                actionBar: {
                  actions: null,
                },
              }}
            />
            <Button onClick={handleOpen} className="open-payment-btn">
              payment
            </Button>
            <div className="Modal">
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <Box sx={style}>
                    <Typography
                      className="modal-title"
                      id="transition-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      The date you've selected:
                    </Typography>
                    <Typography
                      id="transition-modal-description"
                      sx={{ mt: 2 }}
                    >
                      <h3 className="selected-date">
                        {value.$D}.{value.$M + 1}.{value.$y}
                      </h3>
                      <PaymentForm />
                    </Typography>
                  </Box>
                </Fade>
              </Modal>
            </div>
          </LocalizationProvider>
        </div>
      ) : (
        <div className="mobile-date-container">
          <div className="date-button-container">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileDatePicker
                label="For mobile"
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <Button onClick={handleOpen} className="open-payment-btn">
                payment
            </Button>
          </div>
          <div className="Modal">
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <Box sx={style}>
                  <Typography
                    className="modal-title"
                    id="transition-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    The date you've selected:
                  </Typography>
                  <Typography
                    id="transition-modal-description"
                    sx={{ mt: 2 }}
                  >
                    <h3 className="selected-date">
                      {value.$D}.{value.$M + 1}.{value.$y}
                    </h3>
                    <PaymentForm />
                  </Typography>
                </Box>
              </Fade>
            </Modal>
          </div>
        </div>
      )}
    </>
  );
}
